import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';

import { useEvent } from '../hooks/useEvents';
import { useAppStore } from '../stores/appStore';
import LoadingSpinner from '../components/Common/LoadingSpinner';
import EventCard from '../components/Events/EventCard';

const EventDetailsPage = () => {
  const { t } = useTranslation();
  const { eventId } = useParams<{ eventId: string }>();
  const navigate = useNavigate();
  
  const { setCurrentEvent } = useAppStore();
  const { event, isLoading, error } = useEvent(eventId!);

  useEffect(() => {
    if (event) {
      setCurrentEvent(event);
    }
  }, [event, setCurrentEvent]);

  const handleBack = () => {
    navigate(-1);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (error || !event) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            {t('errors.notFound')}
          </h2>
          <button
            onClick={handleBack}
            className="btn-primary"
          >
            {t('common.back')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <button
            onClick={handleBack}
            className="flex items-center space-x-2 text-gray-600 hover:text-gray-800 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>{t('common.back')}</span>
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <EventCard
            event={event}
            size="expanded"
            showCategory
            showProgress
            onClick={() => {}}
            className="mb-6"
          />
        </motion.div>
      </div>
    </div>
  );
};

export default EventDetailsPage;